// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  ReleaseChannel,
} from "./types";


export default __t.row({
  id: __t.u64().primaryKey(),
  appChannelKey: __t.string().name("app_channel_key"),
  appId: __t.string().name("app_id"),
  get channel() {
    return ReleaseChannel;
  },
  currentVersionId: __t.u64().name("current_version_id"),
  updatedAt: __t.timestamp().name("updated_at"),
});
